import React from "react";
import { DateInput } from "semantic-ui-calendar-react";

const SimpleDateComponent = ({
  name = "date",
  defaultValue,
  value,
  label,
  onChange,
  dateFormat,
}) => {
  return (
    <div className="flex-row-center">
      <label>
        <b>{label}</b>
      </label>
      <DateInput
        name={name}
        value={value ?? defaultValue}
        onChange={onChange}
        dateFormat={dateFormat}
        startMode="day"
        onKeyDown={(e) => e.preventDefault()}
        hideMobileKeyboard
      />
    </div>
  );
};

export default SimpleDateComponent;
